// All portfolio copy, metrics and assets in one place.

export const CONTACT = {
  email: "adityarajawat04@gmail.com",
  linkedin: "https://www.linkedin.com/in/aditya-rajawat/",
  linkedinLabel: "linkedin.com/in/aditya-rajawat",
  resume: "https://drive.google.com/file/d/1DErQTE-FjdffmXn3s89FQ2ZHvm9rOwaM/view?usp=sharing",
};

export const ASSETS = {
  youtubeAnalytics:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_182a7b84-390a-4001-9e94-a06090a3e477/artifacts/ugl53h5w_ChatGPT%20Image%20Aug%206%2C%202026%2C%2002_00_12%20PM.png",
  thumbnails: [
    "https://customer-assets-cm19k8pv.emergentagent.net/job_182a7b84-390a-4001-9e94-a06090a3e477/artifacts/ul4lrn2x_Zeel-1.jpeg",
    "https://customer-assets-cm19k8pv.emergentagent.net/job_182a7b84-390a-4001-9e94-a06090a3e477/artifacts/6kw9ixc1_Zeel-2.jpeg",
    "https://customer-assets-cm19k8pv.emergentagent.net/job_182a7b84-390a-4001-9e94-a06090a3e477/artifacts/tlrdf7aq_Zeel-5.jpeg",
    "https://customer-assets-cm19k8pv.emergentagent.net/job_182a7b84-390a-4001-9e94-a06090a3e477/artifacts/fabpjwk9_Zeel-8.jpg",
  ],
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Skills", href: "#skills" },
  { label: "Experience", href: "#experience" },
  { label: "Contact", href: "#contact" },
];

export const HERO_METRICS = [
  { value: 60, prefix: "", suffix: "K+", label: "YouTube subscribers reached" },
  { value: 20, prefix: "+", suffix: "K", label: "Subscribers gained in 4 months" },
  { value: 16, prefix: "", suffix: "%", label: "High-fit prospect rate" },
];

export const MARQUEE_WORDS = [
  "Social Media Marketing",
  "Go-To-Market",
  "Performance Ads",
  "Content Strategy",
  "Growth Automation",
  "Brand Marketing",
];

export const SKILL_TRACKS = [
  {
    id: "social",
    kicker: "Track 01",
    title: "Social & Content",
    blurb: "Building audiences and telling brand stories that actually get watched.",
    skills: ["Social Media Management", "Content Strategy", "Brand Marketing", "Thumbnail & Creative Direction"],
  },
  {
    id: "gtm",
    kicker: "Track 02",
    title: "GTM & Growth Systems",
    blurb: "Turning manual growth work into automated, repeatable systems.",
    skills: ["n8n Automation", "Prospecting & Outreach", "Lead Enrichment", "Workflow Tooling"],
  },
  {
    id: "performance",
    kicker: "Track 03",
    title: "Performance",
    blurb: "Running paid media that answers to CTR, CPC, CPM and ROAS.",
    skills: ["Meta Ads", "Pixel / CAPI Setup", "Audience Targeting", "Weekly Reporting"],
  },
];

export const AI_TOOLS = ["Claude", "ChatGPT", "Gemini Pro", "HiggsField AI", "Veo 3", "n8n"];

export const EXPERIENCE = [
  {
    company: "Fireflies.ai",
    role: "Product Designer",
    period: "2024 — Present",
    note: "Designing product surfaces and marketing-facing experiences for an AI meeting platform.",
  },
  {
    company: "Grah Shakti Mahavastu",
    role: "Performance Marketer — Intern",
    period: "2023",
    note: "Owned Meta Ads setup, targeting, Pixel/CAPI tracking and weekly performance reporting.",
  },
];

export const ABOUT_ARC = [
  { step: "01", label: "Engineer", note: "Started in systems — logic, structure, how things actually work." },
  { step: "02", label: "Product Designer", note: "Moved to craft — clarity, taste, and designing for the person on the other side." },
  { step: "03", label: "Marketer", note: "Now I connect the two: audiences, funnels and growth systems that compound." },
];
